export default __webpack_public_path__ + "static/media/hbs-k-blk-banner-3.f7ef4624.jpg";